import React, { Component } from "react";
import { connect } from "react-redux";
import { awardsWatchOn, awardsWatchOff } from "../../actions/awardsActions";

import ClassCodes from "../classCodes";
import List from "./List";
import Titles from "./Titles";
import VotingOpen from "../debate/VotingOpen";

import _ from "lodash";

class Awards extends Component {
  componentDidMount() {
    this.props.awardsWatchOn();
  }

  componentWillUnmount() {
    this.props.awardsWatchOff();
  }

  render() {
    const { cCode } = this.props.location.params || {};
    const { users } = this.props;
    return (
      <>
        <ClassCodes />
        {cCode && !_.isEmpty(users) && (
          <>
            <Titles />
            <List />
            <VotingOpen votingType={"awards"} />

            {/* NEED TO DEVELOP :: SHOW VISUAL RESULT */}
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users,
  location: state.location
});

export default connect(
  mapStateToProps,
  { awardsWatchOn, awardsWatchOff }
)(Awards);
